import { useCallback, useState } from "react";

const KEY = "fora_history";

/** "since" = count from COUNT_FROM_DATE (default), "all" = include history before it. */
export function useHistoryMode() {
  const [mode, setMode] = useState(() => (localStorage.getItem(KEY) === "all" ? "all" : "since"));
  const toggle = useCallback(() => {
    setMode((m) => {
      const next = m === "all" ? "since" : "all";
      localStorage.setItem(KEY, next);
      return next;
    });
  }, []);
  return [mode, toggle];
}
